const blogPosts = [
  {
    image: 'https://public.readdy.ai/ai/img_res/569ff854bd07c997c162c5951e344ec9.jpg',
    category: 'SEO Tips',
    title: '10 Essential SEO Strategies for 2024',
    date: 'March 15, 2024',
    excerpt: 'Discover the latest SEO techniques that will help your website rank higher in search results and attract more organic traffic.'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Website%20design%20trends%20illustration%2C%20modern%20UI%20UX%20concepts%2C%20responsive%20web%20layouts%2C%20clean%20white%20background%2C%20professional%20digital%20design%20showcase%2C%20contemporary%20interface%20elements&width=600&height=400&seq=blog-design-002&orientation=landscape',
    category: 'Web Design',
    title: 'The Future of Web Design: Trends to Watch',
    date: 'March 12, 2024',
    excerpt: 'Explore the cutting-edge design trends that are shaping the future of web development and user experience.'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Content%20marketing%20strategy%20concept%2C%20blog%20writing%20and%20publishing%2C%20digital%20content%20creation%2C%20clean%20white%20background%2C%20professional%20business%20illustration%2C%20engagement%20metrics%20visualization&width=600&height=400&seq=blog-content-003&orientation=landscape',
    category: 'Content Marketing',
    title: 'How to Create Content That Converts',
    date: 'March 10, 2024',
    excerpt: 'Learn proven strategies for creating compelling content that engages your audience and drives conversions.'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Local%20business%20SEO%20concept%2C%20map%20location%20pins%2C%20local%20search%20optimization%20graphics%2C%20clean%20white%20background%2C%20professional%20marketing%20illustration%2C%20geographic%20targeting%20elements&width=600&height=400&seq=blog-local-004&orientation=landscape',
    category: 'Local SEO',
    title: 'Mastering Local SEO for Small Businesses',
    date: 'March 8, 2024',
    excerpt: 'Boost your local visibility with these proven tactics for dominating local search results in your area.'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Website%20performance%20optimization%20concept%2C%20speed%20metrics%20dashboard%2C%20loading%20time%20analytics%2C%20clean%20white%20background%2C%20professional%20technical%20illustration%2C%20performance%20graphs&width=600&height=400&seq=blog-performance-005&orientation=landscape',
    category: 'Performance',
    title: 'Speed Optimization: Make Your Site Lightning Fast',
    date: 'March 5, 2024',
    excerpt: 'Improve your website loading times and user experience with these essential performance optimization techniques.'
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Mobile%20responsive%20design%20concept%2C%20smartphone%20and%20tablet%20layouts%2C%20adaptive%20web%20interfaces%2C%20clean%20white%20background%2C%20professional%20digital%20showcase%2C%20cross-device%20compatibility&width=600&height=400&seq=blog-mobile-006&orientation=landscape',
    category: 'Mobile Design',
    title: 'Mobile-First Design: Why It Matters',
    date: 'March 3, 2024',
    excerpt: 'Understanding the importance of mobile-first approach in modern web design and how to implement it effectively.'
  }
];

export default function Blog() {
  return (
    <section id="blog" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col lg:flex-row justify-between items-start lg:items-end mb-16 gap-6">
          <div>
            <p className="text-sm text-gray-500 mb-2 uppercase tracking-wider">Latest Insights</p>
            <h2 className="text-5xl lg:text-6xl font-serif italic text-gray-900">SEO Blog</h2>
          </div>
          <p className="text-base text-gray-600 max-w-xl leading-relaxed">
            Stay updated with the latest trends, tips, and strategies in web design and SEO. Our expert insights help you stay ahead of the competition.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {blogPosts.map((post, index) => (
            <article
              key={index}
              className="bg-white hover:transform hover:-translate-y-2 transition-all duration-300 cursor-pointer group"
            >
              <div className="rounded-3xl overflow-hidden mb-5">
                <div className="w-full h-56">
                  <img
                    src={post.image}
                    alt={post.title}
                    className="w-full h-full object-cover object-top grayscale group-hover:grayscale-0 transition-all duration-300 group-hover:scale-110"
                  />
                </div>
              </div>
              <div className="inline-block bg-[#84CC16] text-white text-xs font-semibold px-4 py-1.5 rounded-full mb-4">
                {post.category}
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight line-clamp-2 group-hover:text-[#FF6B6B] transition-colors">
                {post.title}
              </h3>
              <p className="text-xs text-gray-500 mb-3">{post.date}</p>
              <p className="text-sm text-gray-600 leading-relaxed line-clamp-3 mb-4">
                {post.excerpt}
              </p>
              <a href="#" className="text-[#FF6B6B] text-sm font-semibold inline-flex items-center gap-2 hover:gap-3 transition-all">
                Read More
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
